import React from 'react';
import { LayerGroup, LayersControl, WMSTileLayer, TileLayer } from 'react-leaflet';

const { Overlay } = LayersControl

export class OpenSeaMapLayers {

    static getMapLayers(t, orgLayers) {
        const configuredMapLayers = orgLayers;

        let mapLayers = [];
        if (configuredMapLayers != null && configuredMapLayers.some(s => s.layer === "openseamap_data_overlay")) {
            
            mapLayers.push(
                <Overlay name={"Marine Profile (1:920.000))"}>
                    <LayerGroup id="marine_profile" >
                        <WMSTileLayer
                            url={"https://geoserver.openseamap.org/geoserver/gwc/service/wms"}
                            layers={"gebco2021%3Agebco_2021"}
                            format='image/png'
                            transparent='true'
                            opacity="0.7"
                            minZoom={7}
                        />
                    </LayerGroup>
                </Overlay>
            )
            
            mapLayers.push(
                <Overlay name={"Sea Marks"}>
                    <LayerGroup>
                        <TileLayer
                            key="osm_seamarks"
                            tileLayerName="osm_seamarks"
                            layerStyle="osm_seamarks"
                            url={"https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png"}
                            minZoom={7}
                        />
                    </LayerGroup>
                </Overlay>
            )


            
        }

        return mapLayers;
    }

}